import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BAEnglishLiteratureCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. English Literature",
    shortName: "B.A. English",
    duration: "3 years",
    description: "Bachelor's degree program focused on English language, literature, and critical analysis",
    overview: "Bachelor of Arts in English Literature (B.A. English) is a 3-year undergraduate program that provides comprehensive study of English language, British and American literature, literary theory, and critical analysis. This course covers classical works, modern literature, poetry, drama, novels, and literary criticism, preparing students for careers in education, media, publishing, and creative writing.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Good command of English language",
      "Interest in literature and language studies"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "History of English Literature",
          "Poetry and Prose",
          "English Grammar and Usage",
          "Introduction to Literary Theory",
          "Communication Skills",
          "Computer Applications"
        ]
      },
      {
        year: 2,
        subjects: [
          "Shakespeare Studies",
          "Modern English Literature",
          "American Literature",
          "Literary Criticism",
          "Creative Writing",
          "Linguistics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Contemporary Literature",
          "Postcolonial Literature",
          "Comparative Literature",
          "Research Methodology",
          "Project Work",
          "Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "English Teacher",
        "Content Writer",
        "Editor",
        "Journalist",
        "Copywriter",
        "Translator",
        "Publishing Professional",
        "Literary Critic",
        "Creative Writer",
        "Communications Specialist"
      ],
      industries: [
        "Education Sector",
        "Media and Publishing",
        "Advertising Agencies",
        "Digital Marketing",
        "Government Organizations",
        "Non-Profit Sector",
        "Entertainment Industry",
        "Corporate Communications",
        "Online Content Platforms",
        "Translation Services"
      ],
      averageSalary: "₹3-6 LPA (Fresher), ₹10-25 LPA (Experienced)",
      topRecruiters: [
        "Schools and Colleges",
        "Media Houses (TOI, Hindu)",
        "Publishing Companies",
        "Advertising Agencies",
        "Content Creation Companies",
        "Government Departments"
      ]
    },

    admissionProcess: [
      "Merit-based admission through 12th marks",
      "Some universities conduct entrance tests",
      "Direct admission in most colleges",
      "Cut-off based selection",
      "Online application process"
    ],

    topColleges: [
      {
        name: "St. Stephen's College",
        location: "Delhi",
        fees: "₹45,000",
        ranking: "NIRF Ranking: 2"
      },
      {
        name: "Lady Shri Ram College",
        location: "Delhi",
        fees: "₹40,000",
        ranking: "NIRF Ranking: 3"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Premier Government College"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹1,50,000",
        ranking: "Deemed University"
      }
    ],

    skills: [
      "English Language Proficiency",
      "Literary Analysis",
      "Creative Writing",
      "Critical Thinking",
      "Research Skills",
      "Communication Skills",
      "Editing and Proofreading",
      "Public Speaking",
      "Academic Writing",
      "Cultural Awareness"
    ],

    futureScope: "Excellent opportunities in digital content creation, online education, global publishing, international communications, and growing demand for English proficiency worldwide.",

    faqs: [
      {
        question: "What career options are available after B.A. English Literature?",
        answer: "Career options include teaching, journalism, content writing, publishing, advertising, civil services, and further studies like M.A. English or mass communication."
      },
      {
        question: "Can I work in corporate sector with English Literature degree?",
        answer: "Yes, many corporate roles require strong communication skills, including HR, marketing, public relations, and corporate communications."
      },
      {
        question: "Is there scope in digital media?",
        answer: "Yes, excellent opportunities exist in digital content creation, social media marketing, online publishing, and content strategy roles."
      },
      {
        question: "Can I pursue higher studies abroad?",
        answer: "Yes, B.A. English provides good foundation for pursuing M.A., journalism, or creative writing programs in universities abroad."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BAEnglishLiteratureCoursePage;
